import { render, staticRenderFns } from "./EdicaoCompraDialog.vue?vue&type=template&id=611e3873"
import script from "./EdicaoCompraDialog.vue?vue&type=script&lang=js"
export * from "./EdicaoCompraDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports